import LogsTable from "../../common/logs-table";

const SupportLog = ({ data }: any) => {
  return (
    <div>
      {data?.logs?.length > 0 ? (
        <LogsTable data={data.logs} currentPage={data.page} />
      ) : (
        <div className='flex justify-center items-center h-64'>
          <p className='text-gray-500 text-lg'>No data available</p>
        </div>
      )}
    </div>
  );
};

export default SupportLog;
